var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userdata.message.type === "sender")?_c('div',[_c('Sender')],1):_c('div',[_c('Subscriber')],1)}
var staticRenderFns = []

export { render, staticRenderFns }